export const RIPE_SRC_APP = "toolsyaklinca";
